import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  geoSettings = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  connect() {
    console.log("[RequestLocationPermission]", "Controller connected");
  }

  requestLocationPermission() {
    navigator.permissions.query({ name: "geolocation" }).then(
      function (result) {
        if (result.state == "granted") {
          console.log(
            "[RequestLocationPermission]",
            "Geolocation API permission granted.",
          );
        } else if (result.state == "prompt") {
          navigator.geolocation.getCurrentPosition(
            () => {},
            () => {},
            this.geoSettings,
          );
        } else if (result.state == "denied") {
          console.log(
            "[RequestLocationPermission]",
            "Geolocation API permission denied.",
          );
        }
      }.bind(this),
    );
  }

  requestPushNotificationsPermission() {
    Notification.requestPermission().then((permission) => {
      console.log(
        "[RequestLocationPermission]",
        "Push notifications permission: ",
        permission,
      );
    });
  }
}
